import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const weeklyData = [
  { day: 'Mon', orders: 312, revenue: 1.02, visits: 48 },
  { day: 'Tue', orders: 287, revenue: 0.94, visits: 42 },
  { day: 'Wed', orders: 356, revenue: 1.18, visits: 55 },
  { day: 'Thu', orders: 398, revenue: 1.31, visits: 61 },
  { day: 'Fri', orders: 445, revenue: 1.47, visits: 68 },
  { day: 'Sat', orders: 521, revenue: 1.72, visits: 74 },
  { day: 'Sun', orders: 189, revenue: 0.62, visits: 28 },
];

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-popover border border-border rounded-lg p-3 shadow-lg">
      <p className="font-caption text-sm font-semibold text-popover-foreground mb-2">{label}</p>
      {payload?.map((entry) => (
        <div key={entry?.name} className="flex items-center gap-2 mb-1">
          <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: entry?.color }} />
          <span className="font-caption text-xs text-muted-foreground capitalize">{entry?.name}:</span>
          <span className="font-data text-xs font-medium text-popover-foreground">
            {entry?.name === 'revenue' ? `₱${entry?.value}M` : entry?.value}
          </span>
        </div>
      ))}
    </div>
  );
};

export default function WeeklyPerformanceChart() {
  return (
    <div className="card p-4 lg:p-6 chart-panel-depth">
      <h3 className="font-heading font-semibold text-lg lg:text-xl mb-1" style={{ color: '#0F172A', letterSpacing: '0.01em' }}>Weekly Performance</h3>
      <p className="font-caption text-sm mb-4" style={{ color: '#475569' }}>Orders, revenue & visits by day of week</p>
      <div className="w-full chart-height-small" aria-label="Weekly performance area chart">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={weeklyData} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
            <defs>
              <linearGradient id="colorOrders" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#DC2626" stopOpacity={0.25} />
                <stop offset="95%" stopColor="#DC2626" stopOpacity={0} />
              </linearGradient>
              <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#2563EB" stopOpacity={0.25} />
                <stop offset="95%" stopColor="#2563EB" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" strokeOpacity={0.6} />
            <XAxis dataKey="day" tick={{ fontSize: 12, fontFamily: 'var(--font-caption)', fill: '#374151', fontWeight: 600 }} axisLine={{ stroke: '#E5E7EB' }} tickLine={false} />
            <YAxis yAxisId="left" tick={{ fontSize: 11, fontFamily: 'var(--font-data)', fill: '#374151', fontWeight: 600 }} axisLine={false} tickLine={false} width={36} />
            <YAxis yAxisId="right" orientation="right" tick={{ fontSize: 11, fontFamily: 'var(--font-data)', fill: '#374151', fontWeight: 600 }} axisLine={false} tickLine={false} width={36} />
            <Tooltip content={<CustomTooltip />} />
            <Legend wrapperStyle={{ fontSize: '13px', fontFamily: 'var(--font-caption)', color: '#1A1A2E', fontWeight: 600 }} />
            <Area yAxisId="left" type="monotone" dataKey="orders" name="orders" stroke="#DC2626" fill="url(#colorOrders)" strokeWidth={2.5} dot={{ r: 5, fill: '#FFFFFF', stroke: '#DC2626', strokeWidth: 2.5 }} activeDot={{ r: 7 }} />
            <Area yAxisId="right" type="monotone" dataKey="revenue" name="revenue" stroke="#2563EB" fill="url(#colorRevenue)" strokeWidth={2.5} dot={{ r: 5, fill: '#FFFFFF', stroke: '#2563EB', strokeWidth: 2.5 }} activeDot={{ r: 7 }} />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}